import { render, staticRenderFns } from "./BrandIconMdn.vue?vue&type=template&id=78eac9a1&"
import script from "./BrandIconMdn.vue?vue&type=script&lang=js&"
export * from "./BrandIconMdn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports